/* eslint-disable @typescript-eslint/no-explicit-any */
import { Reducer } from 'redux';
import { notificationsSaga } from './sagas';
import questionSlice, { NOTIFICATION_KEY_IN_STORE } from './slice';

export class NotificationModule {
	getRootKeyInStore(): string {
		return NOTIFICATION_KEY_IN_STORE;
	}

	getReducers(): Reducer {
		return questionSlice.reducer;
	}

	getSagas(): () => Generator<any, void, any> {
		return notificationsSaga;
	}
}

export const moduleInstance = new NotificationModule();
